import React from "react";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import labels from "../../../constants/displayFields";

export default function CartItemsHeader({ display, centerAligned = false }) {
  const align = centerAligned ? "center" : undefined;

  return (
    <TableHead style={{ position: "sticky", top: 0, zIndex: 4, backgroundColor: "#fff" }}>
      <TableRow>
        {display.ii_image && <TableCell align={align}>Image</TableCell>}
        {display.ii_item_id && <TableCell align={align}>Item ID</TableCell>}
        {display.ii_sku_number && <TableCell align={align}>{labels.sku_number}</TableCell>}
        {display.ii_barcode && <TableCell align={align}>Barcode</TableCell>}
        {display.ii_description && <TableCell align={align}>Description</TableCell>}
        {display.ii_model && <TableCell align={align}>Model</TableCell>}
        {display.ii_dimensions && <TableCell align={align}>Dimensions</TableCell>}
        {display.ii_qtyRequested && <TableCell align={align}>Quantity Requested </TableCell>}
        {display.ii_building && <TableCell align={align}>Building</TableCell>}
        {display.ii_floor && <TableCell align={align}>Floor</TableCell>}
        {display.ii_room && <TableCell align={align}>Room</TableCell>}
        {display.ii_po_number && <TableCell align={align}>PO Number</TableCell>}
        {display.ii_idsr_number && <TableCell align={align}>IDSR/Proj. Name</TableCell>}
        {display.ii_eoc_number && <TableCell align={align}>EOC</TableCell>}
        {display.ii_deliveryDate && <TableCell align={align}>Delivery Date</TableCell>}
        {display.ii_deliveryTime && <TableCell align={align}>Delivery Time</TableCell>}
        {display.sc_price && <TableCell align={align}>Price</TableCell>}
        <TableCell align={align} />
      </TableRow>
    </TableHead>
  );
}
